import i18n from '@/i18n';
import { LocaleData } from '@/types';

export function synchronizeLocale(locale: LocaleData | undefined): void {
    if (!locale?.current) {
        return;
    }

    document.documentElement.lang = locale.current;
    (window as Window & { locale?: LocaleData }).locale = locale;

    if (i18n.language !== locale.current) {
        void i18n.changeLanguage(locale.current);
    }
}
